<template>
  <section class="prose max-w-3xl mx-auto py-12 px-4">
    <h1 class="text-3xl font-semibold mb-6">Privacy Policy</h1>

    <h2 class="text-xl font-semibold mt-8">Overview</h2>
    <p>Your privacy matters. This policy explains how your data is collected, used, and protected in accordance with UK GDPR.</p>

    <h2 class="text-xl font-semibold mt-8">1. What We Collect</h2>
    <p>When you contact me via the form, I may collect:</p>
    <ul>
      <li>Your name</li>
      <li>Email address</li>
      <li>Message content</li>
    </ul>

    <h2 class="text-xl font-semibold mt-8">2. Purpose of Data Use</h2>
    <p>Your data is only used to respond to your enquiry or provide psychological services. It will never be sold or shared with third parties.</p>

    <h2 class="text-xl font-semibold mt-8">3. Communication</h2>
    <p>All messages are sent via secure email and not stored on this website or in a database.</p>

    <h2 class="text-xl font-semibold mt-8">4. Security</h2>
    <p>This site is protected by HTTPS encryption. I take appropriate measures to safeguard your information.</p>

    <h2 class="text-xl font-semibold mt-8">5. Your Rights</h2>
    <ul>
      <li>Access the data I hold about you</li>
      <li>Request correction or deletion</li>
      <li>Withdraw consent anytime</li>
    </ul>
    <p>Please contact me via the information on the contact page to exercise these rights.</p>

    <h2 class="text-xl font-semibold mt-8">6. Cookies</h2>
    <p>This website does not use cookies or any tracking tools.</p>

    <h2 class="text-xl font-semibold mt-8">7. ICO Registration</h2>
    <p>This website is registered with the UK Information Commissioner’s Office (ICO) as required by law.</p>
    <p><strong>ICO Registration Number:</strong> ZB123456</p>

    <h2 class="text-xl font-semibold mt-8">8. Calendly Integration</h2>
    <p>
      To simplify appointment scheduling, this site uses a service provided by <strong>Calendly LLC</strong>, 271 17th St NW, Atlanta, GA 30363, USA.
    </p>
    <p>
      When you book an appointment via Calendly, your data (e.g. name, email address, message) will be processed directly by Calendly. The data is used solely to organise and confirm your appointment.
    </p>
    <p>
      For more information, please see Calendly’s <a href="https://calendly.com/privacy" target="_blank" rel="noopener noreferrer" class="underline font-semibold">Privacy Policy</a>.
    </p>
    <p>
      The processing of your data in this context is based on your consent (UK GDPR Article 6(1)(a)).
    </p>

    <p class="mt-10 text-sm text-gray-500">Last updated: May 28, 2025</p>
  </section>
</template>
